import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MenuComponent } from '../app/menu/menu.component';
import { SubMenuComponent } from '../app/sub-menu/sub-menu.component';
import { DishComponent } from '../app/dish/dish.component';
import { PromotionComponent } from '../app/promotion/promotion.component';

import { MenuV2Component } from '../app/v2/menu-v2/menu-v2.component';
import { CategoryV2Component } from '../app/v2/category-v2/category-v2.component';
import { DishV2Component } from '../app/v2/dish-v2/dish-v2.component';
import { PromotionV2Component } from '../app/v2/promotion-v2/promotion-v2.component';

const routes: Routes = [
  { path: 'menu', component: MenuComponent },
  { path: 'sub-menu', component: SubMenuComponent },
  { path: 'dish', component: DishComponent },
  { path: 'promotion', component: PromotionComponent },
  { path: 'v2/menu', component: MenuV2Component },
  { path: 'v2/category', component: CategoryV2Component },
  { path: 'v2/dishes', component: DishV2Component },
  { path: 'v2/promotions', component: PromotionV2Component }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
